import * as React from 'react';
import styles from './styles.module.scss';

export interface IMenuProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const Menu: React.FunctionComponent<IMenuProps> = (props) => {
  return (
    <div className={styles['menu']}>
      <ul className={styles['menu__list']}>{props.children}</ul>
      {props.footer && <ul className={styles['menu__footer']}>{props.footer}</ul>}
    </div>
  );
};

Menu.displayName = 'Menu';

export default Menu;
